<template>
  <div class="app app--error">
    <NuxtLayout name="empty-layout">
      <div class="container">
        <!-- 500 Rendering error: {{ $route.fullPath }} -->

        <h1 class="heading heading--1">
          {{ error.statusCode }} {{ error.statusMessage }}
        </h1>

        
      </div>
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
defineProps({
  error: {
    type: Object,
    required: true,
  },
})
</script>
